// LoginModal.js
import React, { useState } from 'react';
import axios from 'axios';
const endPoint = "https://azebrahimi.eastus.cloudapp.azure.com/api/";
const LoginModal = ({ show, onClose, onOpenRegister,onOpenRecoverPassword  }) => {
  const [userName, setEmail] = useState('');
  const [password, setPassword] = useState('');

  const handleLogin = async () => {
    try {
      const response = await axios.post(endPoint+'Security/login', { userName, password });
      debugger
      console.log(response.data);
      // Save response data to localStorage
      localStorage.setItem('userData', JSON.stringify(response.data));
      localStorage.setItem('token', JSON.stringify(response.data.token));
      setEmail("");
      setPassword("");
      window.location.reload();
      onClose(); // Close modal on successful login
    } catch (error) {
      alert("Login failed");
      console.error('Login failed:', error);
    }
  };
  if (!show) return null; // Don't render if modal is not open

  return (
    <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <button type="button" className="close" onClick={onClose}>
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div className="modal-body">
            <div className="d-flex flex-column text-center">
              <h5 className="modal-title mb-4">Login Here</h5>
              <form>
                <div className="form-group">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Your User Name..."
                    value={userName}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <input
                    type="password"
                    className="form-control"
                    placeholder="Your password..."
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  {/* <div className="text-right">
                  <a href="#!" onClick={onOpenRecoverPassword} className="text-info">
                    Forgot Password?
                  </a>
                </div> */}
                </div>
                <button
                  type="button"
                  className="btn btn-info btn-block btn-round"
                  onClick={handleLogin}
                >
                  Login
                </button>
              </form>
              <div className="d-flex justify-content-center mt-4">
                <br />
                <div className="signup-section">
                  Not a member yet?{' '}
                  <a href="#!" onClick={onOpenRegister} className="text-info">
                    Register
                  </a>
                  .
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="modal-backdrop fade show"></div> */}
    </div>
  );
};

export default LoginModal;
